<template>
  <section>
    <div class="container">
      <div class="row justify-content-center justify-content-md-between">
        <div class="col-auto px-0">
          <mdb-btn flat dark-waves icon="arrow-left" type="button" title="Regresar" @click="$router.go(-1)">
            Regresar
          </mdb-btn>
        </div>
      </div>
      <div class="encabezado-detalles">
        <header class="h4-responsive text-center pt-3">Reporte</header>
        <div class="row mx-0 mt-2">
          <div class="col-12 col-md-4">
            <span class="small-block font-titulo">Nombre del reporte</span>
            <p>
              Ventas en dolares
            </p>
          </div>
          <div class="col-12">
            <span class="small-block font-titulo">Descripción</span>
            <p class="mb-1">
              Muestra el total de ventas acumuladas en dinero ($) y peso (kg) de los clientes, filtrado por estado, municipio, parroquia y año. <br>
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <FiltrosTipo1
      :estatusFactura="false" :nombre="false" :fecha="false"
      :zonas="zonasFiltro"
      :year="true"
      @zonasAFiltrar="aplicarFiltrosZonas($event.estados, $event.municipios, $event.parroquias)"
      @eliminarFiltros="eliminarFiltrosSeleccionados"
      @anoAFiltrar="fechaAno = $event; aplicarFiltros();"
      :responsive="responsive"/>
      <div class="row">
      </div>
    </div>
    <div v-if="cargando" class="mensaje-no-items py-3">
      <LoaderKel />
      <p class="texto mt-2">
        Cargando
      </p>
    </div>
    <div v-else-if="!data.length" class="mensaje-no-items pb-3">
      <font-awesome-icon icon="clipboard-list" size="5x" class="icono" />
      <p class="texto">No hay reportes según los parámetros seleccionados</p>
    </div>
    <div v-else class="container">
      <div class="table-container">
        <div class="table-wrapper">
          <table>
            <thead>
              <th>Vendedor</th>
              <th>Cliente</th>
              <th>Zona</th>
              <th>Peso</th>
              <th>Monto en dólares</th>
            </thead>
            <tbody>
              <tr v-for="(c, index) in clientes" :key="index" @click="abrirModal(c)" class="focus">
                <td data-columna="Vendedor">{{c.ven}}</td>
                <td data-columna="Cliente">{{c.nom_cli}} {{ c.ape_cli }}</td>
                <td data-columna="Zona">{{ c.zona }}</td>
                <td data-columna="Peso">{{ numeroAFixed(c.peso) }} kg</td>
                <td data-columna="Monto $">$ {{ numeroAFixed(c.mon_t) }}</td>
              </tr>
              <tr v-if="clientes.length" class="fila-totales">
                <td data-columna="Vendedor" colspan="2">TOTAL</td>
                <td data-columna="Zona"></td>
                <td data-columna="Peso">{{ numeroAFixed(totalPeso) }} kg</td>
                <td data-columna="Monto $">$ {{ numeroAFixed(totalMonto) }}</td>
              </tr>
              <tr v-if="clientes.length" class="fila-totales">
                <td data-columna="Vendedor" colspan="2">PROMEDIO / CLIENTE</td>
                <td data-columna="Zona"></td>
                <td data-columna="Peso">{{ numeroAFixed(totalPeso / clientes.length) }} kg</td>
                <td data-columna="Monto $">$ {{ numeroAFixed(totalMonto / clientes.length) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <AlertaMensaje :alerta-mensaje="alertaMensaje" @cerrar="alertaMensaje.contenido = ''" />
    <ModalProductos :mostrarModal="mostrarModal"
    @cerrar="mostrarModal = $event"
    :cliente="clienteSeleccionado"
    :productosPorMes="nivel2Data"
    :productosDelMes="nivel3Data"
    :ano="fechaAno"
    :nombreMes="mesSeleccionadoNombre"
    @seleccionarMes="seleccionarMes($event)" />
  </section>
</template>

<script>
import {mdbBtn} from 'mdbvue';
import AlertaMensaje from '@/components/AlertaMensaje.vue';
import LoaderKel from '@/components/LoaderKel.vue';
import {apiPost} from '@/funciones/api.js';
import FiltrosTipo1 from '@/components/FiltrosTipo1.vue';
import {convertirNumeroAFixed} from '@/funciones/funciones.js';
import ModalProductos from '../ModalProductos.vue';

export default {
  name: 'VentasDolares',
  components: {
    mdbBtn,
    AlertaMensaje,
    LoaderKel,
    FiltrosTipo1,
    ModalProductos,
  },
  data() {
    return {
      data: [],
      nivel2Data: [],
      nivel3Data: [],
      responsive: {
        estados: 'col-12 col-sm-6 col-lg-4',
      },
      cargando: false,
      alertaMensaje: {contenido: ''},
      zonasFiltro: [],
      fechaAno: (new Date().getFullYear()).toString(),
      estadosAFiltrar: [],
      municipiosAFiltrar: [],
      parroquiasAFiltrar: [],
      timeout: 0,
      mostrarModal: false,
      clienteSeleccionado: null,
      mesSeleccionadoNombre: '',
    };
  },
  computed: {
    clientes() {
      if (!this.data.length) {
        return [];
      }
      const datos = this.data.reduce((acumulado, registro) => {
        const key = registro.id_cli;
        if (!acumulado[key]) {
          acumulado[key] = {
            id_ven: registro.id_ven,
            ven: `${registro.ven_nom} ${registro.ven_ape}`,
            nom_cli: registro.cli_nom,
            zona: `${registro.est_zon} ${registro.ciu_zon} ${registro.sec_zon}`,
            id_cli: registro.id_cli,
            mon_t: 0,
            peso: 0,
            meses_activos: 0,
          };
        }
        acumulado[key].mon_t += Number(registro.mon_t);
        acumulado[key].peso += Number(registro.peso);
        acumulado[key].meses_activos = Number(registro.meses_activos);
        return acumulado;
      }, {});
      return Object.values(datos);
    },
    totalPeso() {
      return this.clientes.reduce((sum, c) => sum + Number(c.peso), 0);
    },
    totalMonto() {
      return this.clientes.reduce((sum, c) => sum + Number(c.mon_t), 0);
    },
  },
  methods: {
    numeroAFixed(num) {
      return convertirNumeroAFixed(num);
    },
    async obtenetFiltros() {
      await apiPost({s: 'zonasMv'}, {})
          .then((result) => {
            this.zonasFiltro = result.data.zon;
          });
      this.cargarDatos();
    },
    cargarDatos() {
      this.cargando = true;
      let dataStr = 'y=' + this.fechaAno;
      if (this.estadosAFiltrar.length) {
        dataStr += '&estados=' + this.estadosAFiltrar.join(',');
      }
      if (this.municipiosAFiltrar.length) {
        dataStr += '&municipios=' + this.municipiosAFiltrar.join(',');
      }
      apiPost({s: 'ventasDolares1Mv'}, dataStr)
          .then((res) => {
            this.data = res.data.nivel1 || [];
            this.cargando = false;
          })
          .catch(() => {
            this.data = [];
            this.cargando = false;
            this.alertaMensaje.contenido = 'Error al cargar los datos';
          });
    },
    abrirModal(cliente) {
      this.clienteSeleccionado = cliente;
      this.nivel3Data = [];
      this.mesSeleccionadoNombre = '';
      this.cargarNivel2(cliente);
    },
    seleccionarMes(mes) {
      const nombres = ['', 'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
        'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
      this.mesSeleccionadoNombre = nombres[Number(mes)] || mes;
      this.cargarNivel3(mes);
    },
    cargarNivel2(cliente) {
      const dataStr = 'y=' + this.fechaAno + '&id_cli=' + cliente.id_cli + '&id_ven=' + cliente.id_ven;
      apiPost({s: 'ventasDolares2Mv'}, dataStr)
          .then((res) => {
            this.nivel2Data = res.data.nivel2 || [];
            this.mostrarModal = true;
            navigator.clipboard.writeText(JSON.stringify(res.data.nivel2 || [], null, 2));
          })
          .catch(() => {
            this.nivel2Data = [];
            this.mostrarModal = true;
          });
    },
    cargarNivel3(mes) {
      if (!this.clienteSeleccionado) return;
      const dataStr = 'y=' + this.fechaAno + '&id_cli=' + this.clienteSeleccionado.id_cli +
        '&id_ven=' + this.clienteSeleccionado.id_ven + '&mes=' + mes;
      apiPost({s: 'ventasDolares3Mv'}, dataStr)
          .then((res) => {
            this.nivel3Data = res.data.nivel3 || [];
            navigator.clipboard.writeText(JSON.stringify(res.data.nivel3 || [], null, 2));
          })
          .catch(() => {
            this.nivel3Data = [];
          });
    },
    aplicarFiltros() {
      if (this.timeout) {
        clearTimeout(this.timeout);
      }
      this.timeout = setTimeout(() => {
        this.cargarDatos();
      }, 500);
    },
    aplicarFiltrosZonas(estadosFil, municipiosFil, parroquiasFil) {
      this.estadosAFiltrar = [];
      this.municipiosAFiltrar = [];
      this.parroquiasAFiltrar = [];

      estadosFil.forEach((e) => {
        this.estadosAFiltrar.push(e.est_zon);
      });
      municipiosFil.forEach((m) => {
        this.municipiosAFiltrar.push(m.ciu_zon);
      });
      parroquiasFil.forEach((p) => {
        this.parroquiasAFiltrar.push(p.sec_zon);
      });

      this.aplicarFiltros();
    },
    eliminarFiltrosSeleccionados() {
      this.fechaAno = (new Date().getFullYear()).toString();
      this.estadosAFiltrar = [];
      this.municipiosAFiltrar = [];
      this.parroquiasAFiltrar = [];

      this.aplicarFiltros();
    },
  },
  mounted() {
    this.obtenetFiltros();
    this.cargarDatos();
  },
};
</script>

<style lang='scss' scoped>
.container {
  max-width: 80dvw;
  margin: 0 auto;
  padding: 20px;
}

.focus {
  cursor: pointer;
}

table {
  border-collapse: collapse;
  width: 100%;
}

thead {
  position: sticky;
  top: 0;
  z-index: 10;
  border-bottom: 1px #dddddd solid;
  background-color: #fafafa;
}

th {
  font-weight: 600;
  text-align: left;
  padding: .6rem .4rem .6rem .4rem;
  white-space: nowrap;
  font-size: .7rem;
  text-transform: uppercase;
}

th:last-child {
  border-right: none;
}

td {
  padding: .3rem;
  padding-bottom: 0;
  border-bottom: 1px solid #eee;
  transition: background-color 0.2s;
  font-size: .9rem;
}

tr:hover td {
  background-color: #f9f9f9;
}

tr:nth-child(even):hover td {
  background-color: #f1f3f4;
}

.table-container {
  border: 1px solid #e7e6e6;
  border-radius: 6px;
  overflow: hidden;
  margin-bottom: 30px;
}

.table-wrapper {
  overflow: auto;
  max-height: 80dvh;
}

.ancho-1 {
  width: 300px;
}

.ancho-2 {
  width: 200px;
}

.ancho-3 {
  width: 100px;
}

.table.actividades {
  @include ul-table-responsive-at ("576px");
}

.tabla-container {
  overflow: auto;
}

.contenedor-tabla {
  max-width: 80dvw;
}

@media (max-width: 1020px) {
  .container {
    width: 100dvw;
    padding: 0px;
  }

  .table-wrapper {
    width: 100dvw;
  }
}

@media (max-width: 576px) {
  .table-wrapper {
    max-height: none;
    overflow-x: hidden;
  }

  table {
    width: 100%;
  }

  thead {
    display: none;
  }

  tr {
    display: flex;
    flex-direction: column;
    border-bottom: 1px solid black;
    width: 90%
  }

  td {
    display: flex;
    flex-wrap: nowrap;
    padding-top: .5rem !important;
    padding-bottom: 0rem !important;
    height: auto !important;
    border: none;
    width: 90% !important;
    min-width: 0;
  }

  td::before {
    content: attr(data-columna) "                          " attr(second-data-columna);
    white-space: pre-wrap;
    font-weight: 500;
    margin-right: .25rem;
    min-width: 105px;
    width: 105px !important;
    flex-shrink: 0;
  }

  td>div {
    display: flex;
    flex-direction: column;
    min-width: 0;
  }

  td>div>p,
  td>div>span {
    word-break: break-word;
    overflow-wrap: break-word;
    min-width: 0;
  }
}

.fila-totales {
  background-color: #f0f4f8;
  border-top: 2px solid #dee2e6;
  font-weight: 600;
}

.fila-totales td {
  border-bottom: none;
  background-color: #f0f4f8;
}

.fila-totales p {
  font-weight: bold !important;
}
</style>
